<template>
  <div class="workDynamicsS-wrap">
    <div class="workDynamicsS">
      <div class="common-title" style="margin-bottom:60px">
        <div class="common-title-left">
          <div class="common-title1"></div>
          <div class="common-title2">工作动态</div>
          <div class="common-title3">Work dynamics</div>
        </div>
        <div class="common-title-right" @click="goWorker()">
          更多
        </div>
      </div>
      <div class="workDynamicsS-content">
        <div class="workDynamicsS-content-bg"></div>
        <div class="workDynamicsS-content-img" v-show="imgShow">
          <img v-if="this.imgs" class="workDynamics-img" :src="this.imgs" />
          <img
            v-else
            class="workDynamics-img"
            src="../../static/webp2/工作动态@2x.webp"
          />
        </div>
        <div class="workDynamicsS-content-items">
          <div class="workDynamicsS-content-items1">
            <div class="workDynamicsS-content-items2">
              <div
                class="workDynamics-item workDynamics-item1"
                v-for="(item, index) in workerList"
                :key="index"
              >
                <div
                  class="workDynamics-item-xh workDynamics-item-xh1"
                  v-if="index < 3"
                >
                  {{ index + 1 }}
                </div>
                <div class="workDynamics-item-dian" v-else></div>
                <div
                  class="workDynamics-item-content workDynamics-item-content1"
                  :class="{ strong: index < 3 }"
                  @click="jump(item)"
                >
                  {{ item.title }}
                  <svg class="icon" aria-hidden="true" v-show="index < 3">
                    <use xlink:href="#icon-a-18_BQ_B_NW_zhiding"></use>
                  </svg>
                </div>
                <div class="workDynamics-item-icon"></div>
                <div class="workDynamics-item-date">
                  {{ item.deployTime.substring(5, 10) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      worker: "",
      pageNum: 1, //当前页码
      pageSize: 5, // 当前页大小
      workerList: [],
      imgs: "",
      imgShow: false
    };
  },
  mounted() {
    GMS.vbus.$on("getId", res => {
      this.worker = res.workerId;
      this.getWorker();
    });
  },
  methods: {
    getWorker() {
      let pram = {
        channels: JSON.stringify([this.worker]),
        filter: JSON.stringify({ deployed: 1 }),
        pageInfo: JSON.stringify({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
      };
      GMS.$http
        .post("/portal/cms/view/contents", pram, {})
        .then(res => {
          if (res.status == 200) {
            if (res.data.bean.length > 0) {
              this.getImg(res.data.bean[0].guid, res.data.bean);
            } else {
              this.imgShow = true;
              return;
            }
          }
        })
        .catch(error => {
          this.imgShow = true;
          this.$Message.error("获取数据异常，请联系管理员");
        });
    },
    //跳转到详情页
    jump(res) {
      let Modal = true;
      GMS.$http
        .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
          userName: JSON.parse(sessionStorage.getItem("person"))
        })
        .then(value => {
          if (value.status == 200) {
            Modal = value.data;
            if (!Modal) {
              GMS.vbus.$emit("Modal-Show");
              return;
            } else {
              this.$router.push({
                path: "/Portal/detail",
                query: {
                  title: "工作动态",
                  total: res.title,
                  name: "",
                  guid: res.guid
                }
              });
            }
          }
        });
    },
    //前往更多页面
    goWorker() {
      let navlist = JSON.parse(sessionStorage.getItem("navList"));
      let item = navlist.find(qwe => qwe.title === "工作动态");
      if (item.childList.length === 0) {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: item.id,
            tagnum: item.childList[0].ordina
          }
        });
      }
    },

    getImg(guid, value) {
      GMS.$http
        .get(`/portal/cms/image?guid=` + guid)
        .then(res => {
          if (res.status == 200) {
            this.imgs = res.data;
          }
          this.workerList = value;
          this.imgShow = true;
        })
        .catch(error => {
          this.workerList = value;
          this.imgShow = true;
          this.$Message.error("获取数据异常，请联系管理员");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.workDynamicsS-wrap {
  width: 100%;
  overflow: hidden;
  margin-bottom: 99px;
  .workDynamicsS {
    width: 1200px;
    margin: 0 auto;
  }
  @media screen and (max-width: 1500px) {
    .workDynamicsS {
      width: 1200px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .workDynamicsS {
      width: 1400px;
    }
  }
  @media screen and (min-width: 1800px) {
    .workDynamicsS {
      width: 1600px;
    }
  }

  .workDynamicsS-content {
    width: 100%;
    height: 451px;
    position: relative;
    .workDynamicsS-content-bg {
      width: 201px;
      height: 362px;
      background-image: linear-gradient(180deg, #00b7f6 0%, #0081e9 100%);
      position: absolute;
      left: 0;
      bottom: 12px;
      z-index: -1;
    }
    .workDynamicsS-content-img {
      position: relative;
      width: 535px;
      height: 380px;
      float: left;
      margin-left: 24px;
      // background: url('../../static/webp2/工作动态@2x.webp');
      // background-size: 535px 380px;
      margin-top: 35px;
      z-index: 2;
    }
    .workDynamics-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .workDynamicsS-content-items {
      width: 909px;
      height: 451px;
      background: #f7f8fa;
      position: absolute;
      right: 0;
      z-index: 0;
    }
    .workDynamicsS-content-items1 {
      width: 641px;
      height: 380px;
      float: right;
      margin-top: 35px;
    }
    .workDynamicsS-content-items2 {
      width: 611px;
      height: 380px;
      margin-left: 30px;
    }
    @media screen and (max-width: 1500px) {
      .workDynamicsS-content-bg {
        width: 201px;
        height: 362px;
        bottom: 12px;
      }
      .workDynamicsS-content-img {
        width: 535px;
        height: 380px;
        margin-left: 24px;
        background-size: 535px 380px;
        margin-top: 35px;
      }
      .workDynamicsS-content-items {
        width: 909px;
        height: 451px;
      }
      .workDynamicsS-content-items1 {
        width: 641px;
        height: 380px;
      }
      .workDynamicsS-content-items2 {
        width: 611px;
        height: 380px;
      }
    }
    @media screen and (min-width: 1500px) and (max-width: 1800px) {
      .workDynamicsS-content-bg {
        width: 214px;
        height: 385px;
        bottom: 20px;
      }
      .workDynamicsS-content-img {
        width: 569px;
        height: 404px;
        margin-left: 26px;
        background-size: 569px 404px;
        margin-top: 40px;
      }
      .workDynamicsS-content-items {
        width: 1146px;
        height: 490px;
      }
      .workDynamicsS-content-items1 {
        width: 805px;
        height: 404px;
        margin-top: 50px;
      }
      .workDynamicsS-content-items2 {
        width: 775px;
        height: 404px;
      }
    }
    @media screen and (min-width: 1800px) {
      .workDynamicsS-content-bg {
        width: 231px;
        height: 411px;
        bottom: 0px;
      }
      .workDynamicsS-content-img {
        width: 615px;
        height: 436px;
        margin-left: 28px;
        background-size: 615px 436px;
        margin-top: 26px;
      }
      .workDynamicsS-content-items {
        width: 1346px;
        height: 490px;
      }
      .workDynamicsS-content-items1 {
        width: 957px;
        height: 436px;
      }
      .workDynamicsS-content-items2 {
        width: 927px;
        height: 436px;
        margin-top: 50px;
      }
    }
    .workDynamics-item {
      cursor: pointer;
      height: 28px;
      margin-bottom: 18px;
      line-height: 28px;
    }
    .workDynamics-item1 {
      margin-top: 17px;
    }
    .workDynamics-item-xh {
      float: left;
    }
    .workDynamics-item-dian {
      float: left;
      width: 4px;
      height: 4px;
      margin-top: 11px;
      margin-left: 4px;
      margin-right: 12px;
      background: #96a2c2;
    }
    .workDynamics-item-xh1 {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #f55858;
      margin-right: 11px;
    }
    .workDynamics-item-xh2 {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #f55858;
      margin-right: 9px;
    }
    .workDynamics-item-xh3 {
      font-weight: 500;
      font-size: 20px;
      color: #ff9d00;
      margin-right: 9px;
    }
    .workDynamics-item-content {
      float: left;
      font-size: 18px;
      color: #0f0f0f;
    }
    .workDynamics-item-content1 {
      font-weight: 500;
      font-size: 20px;
      color: #0f0f0f;
    }
    .workDynamics-item-content2 {
      font-weight: 500;
      font-size: 20px;
      color: #0f0f0f;
    }
    .workDynamics-item-content3 {
      font-weight: 500;
      font-size: 20px;
      color: #0f0f0f;
    }
    .workDynamics-item-icon {
      float: left;
    }
    .workDynamics-item-date {
      float: right;
      font-size: 16px;
      color: #999999;
      margin-right: 20px;
    }
    @media screen and (max-width: 1500px) {
      .workDynamics-item-date {
        margin-right: 20px;
      }
    }
    @media screen and (min-width: 1500px) and (max-width: 1800px) {
      .workDynamics-item-date {
        margin-right: 43px;
      }
    }
    @media screen and (min-width: 1800px) {
      .workDynamics-item-date {
        margin-right: 50px;
      }
    }
  }
  @media screen and (max-width: 1500px) {
    .workDynamicsS-content {
      height: 451px;
    }
  }
  @media screen and (min-width: 1500px) and (max-width: 1800px) {
    .workDynamicsS-content {
      height: 490px;
    }
  }
  @media screen and (min-width: 1800px) {
    .workDynamicsS-content {
      height: 490px;
    }
  }
  .strong {
    font-weight: 700 !important;
  }
  .common-title-right {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workDynamicsS.vue